import React, { useEffect, useState } from 'react'
import { useCalc } from '../../context/CalcContext'
//funding timing constants
const HOW_OFTEN = 12 //months
const FIRST_DEBT_FUNDING = 0

const SavedCapital = (props) => {
  const { procent = false } = props
  const { dataSetRunwayNew, runwayWithout, runwayWith } = useCalc()
  const [maxDiff, setMaxDiff] = useState(0)
  const [savedCash, setSavedCash] = useState(0)

  useEffect(() => {
    if (
      dataSetRunwayNew &&
      dataSetRunwayNew.companyFinancialsWithoutExtraMarketing
    ) {
      const totalCostNoAds =
        dataSetRunwayNew.companyFinancialsWithoutExtraMarketing.reduce(
          (a, b, i) =>
            i ===
            dataSetRunwayNew.companyFinancialsWithoutExtraMarketing.length - 1
              ? a
              : a + b.interest_payment,
          0
        )

      const totalCostWithAds =
        dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing.reduce(
          (a, b, i) =>
            i ===
            dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing.length -
              1
              ? a
              : a + b.interest_payment,
          0
        )

      const firstDebtFundingNoMarketing =
        dataSetRunwayNew.companyFinancialsWithoutExtraMarketing[
          HOW_OFTEN * 1 + FIRST_DEBT_FUNDING
        ].ccs_funding // 0 months
      const secondDebtFundingNoMarketing =
        dataSetRunwayNew.companyFinancialsWithoutExtraMarketing[
          HOW_OFTEN * 2 + FIRST_DEBT_FUNDING
        ].ccs_funding // 12 months
      const firstDebtFundingWithMarketing =
        dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing[
          HOW_OFTEN * 1 + FIRST_DEBT_FUNDING
        ].ccs_funding // 0 months
      const secondDebtFundingWithMarketing =
        dataSetRunwayNew.companyFinancialsWithFejronExtraMarketing[
          HOW_OFTEN * 2 + FIRST_DEBT_FUNDING
        ].ccs_funding // 12 months

      let _traditionalCostNoMarking = 0
      let _traditionalCostWithMarking = 0
      for (let i = 0; i < 25; i++) {
        if (i < 12) {
          _traditionalCostNoMarking +=
            firstDebtFundingNoMarketing *
            (Math.pow(
              1 + dataSetRunwayNew.variables.investor_irr_requirement,
              1 / 12
            ) -
              1)
          _traditionalCostWithMarking +=
            firstDebtFundingWithMarketing *
            (Math.pow(
              1 + dataSetRunwayNew.variables.investor_irr_requirement,
              1 / 12
            ) -
              1)
        } else if (i < 24) {
          _traditionalCostNoMarking +=
            secondDebtFundingNoMarketing *
            (Math.pow(
              1 + dataSetRunwayNew.variables.investor_irr_requirement,
              1 / 12
            ) -
              1)
          _traditionalCostWithMarking +=
            secondDebtFundingWithMarketing *
            (Math.pow(
              1 + dataSetRunwayNew.variables.investor_irr_requirement,
              1 / 12
            ) -
              1)
        }
      }

      const _savedCash = Math.max(
        _traditionalCostNoMarking - totalCostNoAds,
        _traditionalCostWithMarking - totalCostWithAds
      )

      const _maxDiff = Math.max(
        _traditionalCostNoMarking / totalCostNoAds - 1,
        _traditionalCostWithMarking / totalCostWithAds - 1
      )

      setSavedCash(_savedCash)
      setMaxDiff(_maxDiff)

      // console.log('savedCash', savedCash)
      // console.log('maxdiff', _maxDiff)
    }
  }, [dataSetRunwayNew])

  // const totalCostNoMarketing =
  // TODO: START HERE -- VALUE NOT MATCHING EXCEL!!
  return !procent ? (
    <>{Math.round(savedCash / 1000)}k</>
  ) : (
    <>(~{Math.round(maxDiff * 100)}% vs traditional processes)</>
  )
}

export default SavedCapital
